// extracted by mini-css-extract-plugin
export var externalLink = "_aw-0";
export var internalLinkLabel = "_aw-1";